<style scoped>
li a{
  cursor: pointer;
}
</style>
<template lang="pug">
  div(:class='{fixed: fixed === true}', :style='{top: top}')
    .input-field
      input#searchKey(type='text', @keyup='search', ref='searchField')
      label(for='searchKey', :class='{active: searchFieldActive}') Search
    p.list-title Categories
    ul
      li(v-for='category in categories')
        a.list-item(:class='{active: activeCategory === category}', @click='filterCategory') {{category}}
</template>
<script>
/* eslint-disable no-undef */
export default {
  name: 'appdrinkfilter',
  props: [
    'categories',
    'searchKey',
    'activeCategory',
    'fixed',
    'top',
    'onFilterCategory',
    'onSearchKeyword'
  ],
  data () {
    return {
      searchTimeout: null,
      searchFieldActive: false
    }
  },
  mounted () {
    this.$refs.searchField.value = this.searchKey ? this.searchKey : null
    this.searchFieldActive = !!this.searchKey

    var elems = document.querySelectorAll('select')
    this.$M.FormSelect.init(elems, {})
  },
  methods: {
    search (e) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      this.searchFieldActive = !!e.target.value

      this.searchTimeout = setTimeout(() => {
        this.$emit('onSearchKeyword', e.target.value)
        if (typeof this.onSearchKeyword === 'function') {
          this.onSearchKeyword(e.target.value)
        }
      }, 1000)
    },
    filterCategory (e) {
      this.$emit('onFilterCategory', e.target.text)
      if (typeof this.onFilterCategory === 'function') {
        this.onFilterCategory(e.target.text)
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/app-drink-filter.vue